import { useMapSlice } from 'app/containers/Map/slice';
import { useTaskSlice } from 'app/containers/Task/slice';
import { selectCheckedRouteIds } from 'app/containers/Task/slice/selectors';
import { RouteData } from 'app/containers/Task/slice/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useRouteCheck = ({ routes }: { routes: RouteData[] }) => {
  const dispatch = useDispatch();
  const taskActions = useTaskSlice().actions;
  const mapActions = useMapSlice().actions;

  const checkedRouteIds = useSelector(selectCheckedRouteIds);

  const routesCount = routes.length;

  const isAllRoutesChecked = Boolean(
    routesCount && routesCount === checkedRouteIds.length,
  );

  // Checked routes cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(taskActions.setCheckedRouteIds([]));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onToggleAllRoutes = () => {
    if (isAllRoutesChecked) {
      dispatch(taskActions.setCheckedRouteIds([]));
    } else {
      const allRouteIds = routes.map(route => route.id);
      dispatch(taskActions.setCheckedRouteIds(allRouteIds));
    }
  };

  const onRoutesCheck = (routeIds: number[], coordinates?: any[]) => {
    const isChecked = checkedRouteIds.includes(routeIds[0]);
    let updatedIds = [...checkedRouteIds];
    if (isChecked) {
      updatedIds = updatedIds.filter(id => !routeIds.includes(id));
    } else {
      if (Array.isArray(coordinates)) {
        dispatch(mapActions.setFitCoordArrOnMap(coordinates));
      }
      updatedIds = [...updatedIds, ...routeIds];
    }

    dispatch(taskActions.setCheckedRouteIds(updatedIds));
  };

  const checkedRoutes = routes.filter(route =>
    checkedRouteIds.includes(route.id),
  );

  return {
    isAllRoutesChecked,
    checkedRouteIds,
    checkedRoutes,
    onRoutesCheck,
    onToggleAllRoutes,
  };
};
